import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-317">
    <App data-id="element-318" />
  </BrowserRouter>, document.getElementById('root'));